// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__1RZhF","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2FdIC"};